import React from 'react';
import Payments from '../assets/images/Payments.svg';

export default () => {
  return <img src={Payments} alt="" />;
};
